import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import {
  EntityState,
  entityStateSchema,
} from '../../../schemas/entity-state.schema';
import { Role, roleSchema } from '../../../schemas/role.schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Remove a user from a Trimble Maps product
 * @param product Trimble Maps product name
 * @param accountId Id of the account
 * @param request.email user's email
 * @param request.role user's product role
 * @param request.userState user's entity state
 * @returns user info passed in the request
 */
export function postProductsAccountsUsersRemove(
  this: unknown,
  product: string,
  accountId: number,
  request: {
    email: string;
    role: Role;
    userState: EntityState;
  }
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}/users/remove`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(request),
      }
    )
  ).pipe(
    selectData(
      z.object({
        email: z.string(),
        role: roleSchema,
        userState: entityStateSchema,
      })
    )
  );
}
